import i18n from "../../../i18n";
import GreenCheckCircleIcon from "../../../images/portal/greenCheckCircle.svg?react";
import PurpleExclamationCircleIcon from "../../../images/portal/purpleExclamationCircle.svg?react";
import styles from "./IntegrationDetected.module.css";

export function IntegrationDetected({ detected, integration }: { detected?: boolean; integration: string }) {
    if (detected === undefined) return null;

    return (
        <span className={styles.message}>
            {detected ? <GreenCheckCircleIcon /> : <PurpleExclamationCircleIcon />}
            {detected
                ? i18n.t("portal.components.settings.integrationDetectedTSX.detected", { integration })
                : i18n.t("portal.components.settings.integrationDetectedTSX.undetected", { integration })}
        </span>
    );
}